import type { DefaultRootState } from 'react-redux';
import { getCurrentWorkspaceIdSelector } from '@app/reducers/app';
import { AI, STANDARD } from './constants';

export const isAiImport = (method: 'standard' | 'ai') => method === AI;
export const isStandardImport = (method: 'standard' | 'ai') => method === STANDARD;

export const shouldRenderLoader = (
  uploadInitiated: boolean,
  pdfIsReady: boolean,
  assetUploadErrorCode: string | number | undefined,
) => {
  const hasError = Boolean(assetUploadErrorCode);
  if (!uploadInitiated) {
    return false;
  }
  return !pdfIsReady && !hasError;
};

export const isImportButtonDisabled = (
  uploadedPdfName: string | null,
  pdfIsReady: boolean,
  importMethod: 'standard' | 'ai',
  extractionState: {
    loading: boolean;
  },
): boolean => {
  const isPdfMissing = !uploadedPdfName || (isAiImport(importMethod) && !pdfIsReady);
  const isAiLoading = isAiImport(importMethod) && extractionState.loading;

  return isPdfMissing || isAiLoading;
};

export const getWorkspaceQuerySelector = (
  state: DefaultRootState,
  {
    queryName,
  }: {
    queryName: string;
  },
) => `workspace-${getCurrentWorkspaceIdSelector(state)}::${queryName}`;
